module.exports = __webpack_public_path__ + "img/stop.9bdbaa90.png";